
import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import JobList from "@/components/jobs/JobList";
import JobDetail from "./JobDetail";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { AIJobCreationDialog } from "@/components/jobs/ai-creation/AIJobCreationDialog";
import { ErrorBoundary } from "@/components/error-handling/ErrorBoundary";
import { JobsEmptyState } from "@/components/empty-states/JobsEmptyState";
import { useJobs } from "@/hooks/useJobs";

const JobsMain = () => {
  const [showJobForm, setShowJobForm] = useState(false);
  const { data: jobs = [], isLoading } = useJobs();

  const handleCreateJob = () => {
    setShowJobForm(true);
  };

  if (!isLoading && jobs.length === 0) {
    return (
      <div className="w-full space-y-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-3xl font-bold">Jobs</h1>
            <div className="text-sm text-muted-foreground">
              Create compelling job postings with AI assistance and track applicants.
            </div>
          </div>
        </div>
        
        <JobsEmptyState onCreateJob={handleCreateJob} />

        <AIJobCreationDialog 
          open={showJobForm} 
          onClose={() => setShowJobForm(false)}
          onSuccess={() => window.location.reload()}
        />
      </div>
    );
  }

  return (
    <div className="w-full"> 
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl font-bold">Jobs</h1>
          <div className="text-sm text-muted-foreground">
            Create compelling job postings with AI assistance and track applicants.
          </div>
        </div>
        <Button onClick={handleCreateJob}>
          <Plus className="h-4 w-4 mr-2" />
          Create your Job
        </Button>
      </div>
      
      <ErrorBoundary>
        <JobList />
      </ErrorBoundary>

      <AIJobCreationDialog 
        open={showJobForm} 
        onClose={() => setShowJobForm(false)}
        onSuccess={() => window.location.reload()}
      />
    </div>
  );
};

const Jobs = () => {
  return (
    <Routes>
      <Route path="/" element={<JobsMain />} />
      <Route path="/:id" element={<JobDetail />} />
    </Routes>
  );
};

export default Jobs;
